import { render } from "./Social.vue?vue&type=template&id=180965e2&scoped=true"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"

import "./Social.vue?vue&type=style&index=0&id=180965e2&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/tutuyoutoo-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180965e2"]])

export default __exports__